<template>
  <div class="card px-1 py-4 p-sm-4 mb-3">
    <div class="text-center">

      <h5><a :href="getOfficeUrl" class="textlink">{{ getOfficeTitle }}</a></h5>
      <span class="small">
        <small>Режим работы: с {{ getOfficeWorkTimeStart }} до {{ getOfficeWorkTimeEnd }}</small>
      </span>
      <div class="mb-3" v-if="cUserSale != false ">Ваша скидка: <span class="mb-3 sale-badge"> {{ cUserSale }}%</span>
      </div>
      <div class="text-center small noselect">
        <span class="icon prev" @click="prevDate()" :class="{disable:!viewPrew}"></span>
        <span class="dateselect-label-wrap">
        <Datepicker
            ref="datepickerRef"
            :locale="locate"
            :lowerLimit="new Date()"
            weekdayFormat="EEEEE"
            v-model="datepicker"
            inputFormat="dd.MM.yyyy"
            position="center"
            @update:modelValue="onDateChanged"
            class="dateselect-label"/>
        </span>
        <span  @click="nextDate()" class="icon next"></span>
        <div>
          {{ dateFormatDay }}
        </div>
      </div>
    </div>

    <template v-if="this.$store.state.vMode == 1">
      <div class="booking-table my-4">
        <div class="syncscroll-wrap">
          <TimeLine v-bind:startTime="getOfficeWorkTimeStart" v-bind:endTime="getOfficeWorkTimeEnd"/>
          <div class="d-flex">
            <div class="relblock">
              <CabCard
                  v-for="(cabId) in getCabinetsSortData"
                  v-bind:key="cabId"
                  v-bind:cab-id="Number(cabId)"
                  v-bind:office-id="Number(officeId)"
              />
            </div>
            <div class="table-content wrapper-scroll"
                 @mousedown="mousedown"
                 @mouseup="mouseup"
                 @mouseleave="mouseup"
                 @mousemove="mouseMove"
                 ref="targetRefScrollStart"
            >
              <BTWallCells
                  v-for="(cabId) in getCabinetsSortData"
                  v-bind:key="cabId"
                  v-bind:cab-id="Number(cabId)"
                  v-bind:cab-data="getCabinetsPrices[cabId]"
                  v-bind:startTime="getOfficeWorkTimeStart"
                  v-bind:endTime="getOfficeWorkTimeEnd"
                  v-bind:timeZone="getOfficeTimezone"

              />
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="booking-table vertical my-4">
        <div class="syncscroll-wrap">
          <div class="sticky" :class="[getXClass]">
            <div class="wrapper-scroll  noselect mousescroll"
                 @mousedown="mousedown"
                 @mouseup="mouseup"
                 @mouseleave="mouseup"
                 @mousemove="mouseMove"
                 @scroll="scrollHandler"
                 ref="mscroll"
            >
              <span class="l-arrow" @click="sLeft"></span><span class="r-arrow" @click="sRight"></span>
              <div class="vertical-cells-wrap">
                <div class="cabinet-top-wrapper first"></div>
                <template v-for="(cabId) in getCabinetsSortData" v-bind:key="cabId">
                  <CabCard
                      v-bind:cab-id="Number(cabId)"
                      v-bind:office-id="Number(officeId)"
                  />
                </template>
              </div>
            </div>
          </div>
          <div class="old-view" :class="[{vMode0: this.$store.state.vMode == 0},getXClass]">
            <div class="vertical-timeline">
              <TimeLine v-bind:startTime="getOfficeWorkTimeStart" v-bind:endTime="getOfficeWorkTimeEnd"/>
            </div>
            <div class="table-content wrapper-scroll size-container vertical-cells-wrap"
                 @mousedown="mousedown"
                 @mouseup="mouseup"
                 @mouseleave="mouseup"
                 @mousemove="mouseMove"
                 ref="targetRefScrollStart"

            >
                  <BTWallCells
                      v-for="(cabId) in getCabinetsSortData"
                      v-bind:key="cabId"
                      v-bind:cab-id="Number(cabId)"
                      v-bind:cab-data="getCabinetsPrices[cabId]"
                      v-bind:startTime="getOfficeWorkTimeStart"
                      v-bind:endTime="getOfficeWorkTimeEnd"
                      v-bind:timeZone="getOfficeTimezone"
                  />

            </div>
          </div>
        </div>
      </div>
    </template>

  </div>
</template>

<script>

import TimeLine from "@/components/TimeLine";
import BTWallCells from "@/components/BookingTable/BTWallCells";
import CabCard from "@/components/BookingTable/CabCard";
import {dateFormat} from "@/dateFormat";
import Datepicker from "vue3-datepicker";
import {ru} from "date-fns/locale";


export default {
  components: {
    Datepicker,
    CabCard,
    BTWallCells,
    TimeLine
  },
  props: {
    officeId: Number
  },
  provide() {
    // use function syntax so that we can access `this`
    return {
      officeId: Number(this.officeId),
      selectData: this.getSelectData,
      mySelectData: this.getMySelectData,
      errorData: this.getErorrData
    }
  },
  name: 'BookingTable',
  data() {
    return {
      daysTitle: [
        'воскресенье',
        'понедельник',
        'вторник',
        'среда',
        'четверг',
        'пятница',
        'суббота'
      ],
      viewPrew: false,
      speed: 1, // Скорость скролла.
      left: 0, //нажали мышку - сохраняем положение скролла
      drag: false,
      coorX: 0, // нажали мышку - сохраняем координаты.
      // workTimeStart: "10:00",
      // workTimeEnd: "22:00",
      locate: ru,
      datepicker: '',
    }
  },
  mounted() {

    this.scrollToWorkPill() //# включить
    // подключаем синхронизацию скролинага ячеек и таймфрейма
    this.scrollInit(); //# включить
    this.fakeScroll()
    // подписываемся на события wall cell, когда надо перепроверить все правила
    this.$emitter.off('revalidate_' + this.officeId)
    this.$emitter.on('revalidate_' + this.officeId, () => {
      // console.log('Надо обновить все ячейки в officeId' + this.officeId)
      // создаем событие для кабинетов, для проверки правил
      this.$emitter.emit('revalidate_walls_' + this.officeId)
    })

    // создаем событие для автоматического выбора ячеек
    this.$emitter.off('autoselect_' + this.officeId)
    this.$emitter.on('autoselect_' + this.officeId, (data) => {
      for (var key of Object.keys(data)) {
        this.$emitter.emit('autoselect_pill_' + data[key], data[key])
      }
    })
  },
  created() {
    if ([0,1].indexOf(this.$store.state.vMode ) == -1 ){
      this.$store.dispatch('setVMode', 0);
    }
    this.datepicker = new Date(this.$store.state.date)

    // console.log('Tut 33',this.$store.state.selector.new)

    // let settingsMemory = this.$cookies.get('selectorDataBeforeAddBalance');
    // console.log('Tut 33', settingsMemory)
    // if(settingsMemory.officeSelectData) {
    //   this.$store.dispatch('selector/selectNewCellCabinetLoad', settingsMemory.officeSelectData)
    // }
    // this.workTimeStart = this.getOfficeWorkTimeStart;
    // this.workTimeEnd = this.getOfficeWorkTimeEnd;
  },
  updated() {
    this.scrollInit(); //# включить
    this.fakeScroll()
    this.scrollToWorkPill() //# включить
    // let brick = this.$refs.targetRefScrollStart.querySelectorAll('.outdate');
    // if (!brick.length && this.$refs.targetRefScrollStart.scrollLeft > 0) {
    //     this.$refs.targetRefScrollStart.scrollLeft = 0;
    //     let syncscroll = this.$refs.targetRefScrollStart.closest('.syncscroll-wrap');
    //     if (syncscroll) {
    //       syncscroll.querySelector('.wrapper-scroll.mousescroll').scrollLeft = 0;
    //     }
    // }
  },
  watch: {
    // '$store.state.date'(val) {
    //   let nowDate = dateFormat.formatDate(dateFormat.getDateNowWithTimeZone())
    //   if (dateFormat.compare(val, nowDate) == '>') {
    //     // console.log('ALEX','VIEW')
    //     this.viewPrew = true
    //   } else {
    //     // console.log('ALEX','NOW')
    //     this.viewPrew = false
    //   }
    //   this.datepicker = new Date(this.$store.state.date)
    // },
    '$store.state.date'(val) {
      const nowDate = dateFormat.formatDate(dateFormat.getDateNowWithTimeZone());
      this.viewPrew = dateFormat.compare(val, nowDate) == '>';

      const newDate = new Date(val);

      if (!this.datepicker || this.datepicker.getTime() !== newDate.getTime()) {
        this.datepicker = newDate;
      }
    },
    '$store.state.x'() {
      this.fakeScroll()
    },
    // datepicker(val) {
    //    let date = dateFormat.formatDate(val)
    //   this.$emitter.emit('changeDate', date)
    // },
  },
  computed: {
    getXClass() {
      return 'xsize-' + this.$store.state.x;
    },
    cUserSale: function () {
      if (this.cIsUser) {
        if (this.officeId in this.$store.state.user.userSales) {
          return Number(this.$store.state.user.userSales[this.officeId])
        } else {
          return Number(this.$store.state.user.userSale);
        }
      }
      return false;
    },
    cIsUser: function () {
      return this.$store.state.user !== false ? true : false;
    },
    dateFormat() {
      return dateFormat.strToFormat(this.$store.state.date)
    },
    dateFormatDay() {
      let date = new Date(this.$store.state.date)
      let dayNum = date.getDay()
      return this.daysTitle[dayNum]
    },
    getCalcKey() {
      return this.calcKey;
    },
    getErorrData() {
      return this.$store.state.selector.error
    },
    getSelectData() {
      return this.$store.state.selector.new
    },
    getMySelectData() {
      return this.$store.state.selector.my
    },
    getOfficeWorkTimeStart() {
      return this.$store.state.office.data[this.officeId]['workTimeStart']
    },
    getOfficeWorkTimeEnd() {
      return this.$store.state.office.data[this.officeId]['workTimeEnd']
    },
    getOfficeTitle() {
      return this.$store.state.office.data[this.officeId]['title']
    },
    getOfficeTimezone() {
      return this.$store.state.office.data[this.officeId]['timeZone']
    },
    getOfficeUrl() {
      let pref = '';
      let office = this.$store.state.office.data[this.officeId];
      if ('city' in office && office['city'] != 'msc' && office['city'] != null) {
        pref = '/' + office['city']
      }
      return pref + '/places/' + this.$store.state.office.data[this.officeId]['url_alias']
    },
    // getCabinetsTimeRange(){
    //     return this.calcTimeRange()
    // },
    getCabinetsPrices() {
      // console.log(this.$store.state.cabinet.data.cabinetsPrices[this.officeId])

      return this.$store.state.cabinet.data.cabinetsPrices[this.officeId]
    },
    getCabinetsSortData() {
      return this.$store.state.cabinet.data.cabinetsSortData[this.officeId]
    },
  },
  methods: {
    onDateChanged(val) {
      if (!val) return;

      const date = dateFormat.formatDate(val);

      if (date === this.$store.state.date) {
        this.blurActiveElement();
        return;
      }

      this.$emitter.emit('changeDate', date);

      this.$nextTick(() => {
        this.blurActiveElement();
      });
    },

    blurActiveElement() {
      if (document.activeElement && typeof document.activeElement.blur === 'function') {
        document.activeElement.blur();
      }
    },
    revalidate() {
      console.log('revalidate')
    },
    scrollToWorkPill() {
      // скролим до ячейки, которая еще актуальна (время не истекло)

      let brick = this.$refs.targetRefScrollStart.querySelectorAll('.outdate');
      if (brick.length) {
        let outBlockCell = brick[brick.length - 1].closest('.cell');
        let offstLeft = outBlockCell.offsetLeft;
        let offstWidth = outBlockCell.offsetWidth;
        // скролим таймфрейм
        let syncscroll = this.$refs.targetRefScrollStart.closest('.syncscroll-wrap');
        if (syncscroll) {
          syncscroll.querySelector('.wrapper-scroll.mousescroll').scrollLeft = offstLeft + offstWidth;
        }
        // скролит ячейки
        this.$refs.targetRefScrollStart.scrollLeft = offstLeft + offstWidth;
      } else {
        // скролим таймфрейм
        let syncscroll = this.$refs.targetRefScrollStart.closest('.syncscroll-wrap');
        if (syncscroll) {
          syncscroll.querySelector('.wrapper-scroll.mousescroll').scrollLeft = 0;
        }
        this.$refs.targetRefScrollStart.scrollLeft = 0;
      }
    },
    prevDate() {
      this.$emitter.emit('prevDate')
    },
    nextDate() {
      this.$emitter.emit('nextDate')
    },

    // eslint-disable-next-line no-unused-vars
    mousedown(e) {
      let el = e.currentTarget;
      this.drag = true
      this.coorX = e.pageX - el.offsetLeft;
      this.left = el.scrollLeft;
    },
    mouseup() {
      this.drag = false;
    },
    // eslint-disable-next-line no-unused-vars
    mouseMove(e) {
      if (this.drag) {
        let el = e.currentTarget;
        let scroll = this.left - (e.pageX - el.offsetLeft - this.coorX) * this.speed;
        el.scrollLeft = scroll;
      }

    },
    scrollInit() {

      let mousescroll = document.querySelectorAll('.booking-table .mousescroll');

      for (let elem of mousescroll) {

        elem.addEventListener('scroll', ({currentTarget}) => {
          // let currentTarget = e.currentTarget;
          // console.log(e,currentTarget)
          let parent = elem.closest('.booking-table');
          if (parent) {
            let syncscroll = parent.querySelector('.table-content.wrapper-scroll');

            if(syncscroll){
              syncscroll.scrollLeft = currentTarget.scrollLeft
            }

          }
        })
      }

      let syncscroll = document.querySelectorAll('.booking-table .table-content.wrapper-scroll');

      for (let elem of syncscroll) {

        elem.addEventListener('scroll', ({currentTarget}) => {

          let parent = elem.closest('.booking-table');
          if (parent) {
            let syncscroll = parent.querySelector('.mousescroll:first-child');
            syncscroll.scrollLeft = currentTarget.scrollLeft
          }

        })
      }
    },
    itemScroll(child, left = true) {
      let item = child.closest('.mousescroll');
      let tracksW = item.scrollWidth;
      let elemW = item.clientWidth;
      tracksW = tracksW > elemW ? elemW * 2 : tracksW;
      let step = left ? tracksW / 3 : -tracksW / 3
      this.slider(item, step, 500)
    },
    slider(slider, step, period) {
      const startTime = Date.now()
      const startLeft = slider.scrollLeft
      const render = () => {
        const dt = Date.now() - startTime
        if (dt < period) {
          slider.scrollLeft = startLeft + step * dt / period
          requestAnimationFrame(render)
        }
      }
      requestAnimationFrame(render)
    },
    sLeft({currentTarget}) {
      this.itemScroll(currentTarget, false)
    },
    sRight({currentTarget}) {
      this.itemScroll(currentTarget, true)
    },
    fakeScroll(){
      if(this.$store.state.vMode == 0){
        // фейковые движения, для срабатывания показа стрелочки прокрутки
        this.$refs.mscroll.scrollLeft = 1 //# включить
        this.$refs.mscroll.scrollLeft = 0 //# включить
      }
    },
    scrollHandler({currentTarget}) {

      let
          scrollLeft = Math.round(currentTarget.scrollLeft),
          scrollWidth = Math.round(currentTarget.scrollWidth),
          clientWidth = Math.round(currentTarget.clientWidth)

      if (scrollLeft < 5) {
        currentTarget.querySelector('.l-arrow').classList.remove('show');
      } else {
        currentTarget.querySelector('.l-arrow').classList.add('show');
      }

      if (scrollWidth == Math.round(scrollLeft + clientWidth)) {
        currentTarget.querySelector('.r-arrow').classList.remove('show');
      } else {
        currentTarget.querySelector('.r-arrow').classList.add('show');
      }
    },
  }
}
</script>
<style scoped>


.r-arrow,
.l-arrow {
  background-color: #e7d9b3;
  position: absolute;
  display: block;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 65%;
  width: 32px;
  height: 100%;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%23000000' class='bi bi-chevron-right' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E");
  right: 0px;
  top: 0px;
  transition: all ease .4s;
  z-index: 15;
  opacity: 0;
  box-shadow: -2px 0px 8px -5px #000;
}

.r-arrow.show,
.l-arrow.show {
  opacity: 1;
}

.r-arrow:hover,
.l-arrow:hover {
  background-color: #ffeda3;
  cursor: pointer;
}

.l-arrow {
  transform: rotate(180deg);
  left: 0px;
  box-shadow: 2px 0px 8px -5px #000;
}


.booking-table.vertical .cabinet-top-wrapper.first{
  width: 4rem!important;
  //min-width: calc(4rem - 3px)!important;
  min-width: 4rem!important;
  position: relative;
  //left:-2px;
  margin-right: 2px;
  background: transparent;
}

.old-view{
  display: flex;
  flex-direction: row;

}

.vertical-timeline{
  display: flex;
  flex-direction: column;
  margin-right: 2px;
  width: 4rem!important;
  min-width: 4rem!important;
}
.noselect {
  user-select: none;
}

.disable {
  opacity: .1;
}

.icon {
  position: relative;
  display: inline-block;
  width: 1.2rem;
  height: 1.2rem;
  background-repeat: no-repeat;
  background-position: bottom;
  position: relative;
  top: 4px;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color ease .4s;
}

.icon:hover {
  background: #ffdec0;
}

.icon.next {

  margin-left: .5rem;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23e07a5f' class='bi bi-arrow-right-circle' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z'/%3E%3C/svg%3E");
}

.icon.prev {
  margin-right: .5rem;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23e07a5f' class='bi bi-arrow-left-circle' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z'/%3E%3C/svg%3E");
}

.booking-table {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  will-change: transform;
}

/*.cab-info-wrap {*/
/*  min-width: 250px;*/
/*}*/
.wrapper-scroll {
  overflow: hidden;
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;

}

.wrapper-scroll::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.wrapper-scroll .scroll-y {
  display: none !important;
}

.vertical .table-content {
  display: flex;
  width: 100%;
}


.relblock {
  max-width: 250px;
  position: relative;
}


.relblock-wrap {
  background-color: #fff;
  transition: background-color ease .7s;
}

.relblock-wrap.loading {
  background-color: #faf9f9;
}

/*.relblock {*/
/*  opacity: 1;*/
/*  transition: opacity ease .7s;*/
/*}*/

/*.relblock-wrap.loading .relblock {*/
/*  opacity: 0;*/
/*}*/

.textlink {
  color: #444;
  text-decoration: none;
}

@media (max-width: 670px) {
  .relblock {
    max-width: 120px;
  }
}

</style>

<style>
.dateselect-label-wrap{
  display: inline-block;
}
.dateselect-label-wrap input{
  font-size: 1rem;
  display: inline-block;
  border: none;
  outline: 1px solid #ccc;
  border-radius: 3px;
  max-width: 200px;
  text-align: center;
}

.dateselect-label-wrap input:focus,
.dateselect-label-wrap input:active
{
  border: none;
  outline: 1px solid #eee;
}
</style>